var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileFaceFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM1.07492 6C1.07492 8.72005 3.27995 10.9251 6 10.9251C8.72005 10.9251 10.9251 8.72005 10.9251 6C10.9251 3.27995 8.72005 1.07492 6 1.07492C3.27995 1.07492 1.07492 3.27995 1.07492 6Z",
    fill: "#027BFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 4.75,
    r: 0.75,
    fill: "#027BFC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 4.75,
    r: 0.75,
    fill: "#027BFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52277 6.75C8.78634 6.75 9.00387 6.96498 8.96212 7.22522C8.92516 7.45562 8.86135 7.68146 8.77164 7.89805C8.62087 8.26203 8.3999 8.59274 8.12132 8.87132C7.84274 9.1499 7.51203 9.37087 7.14805 9.52164C6.78407 9.6724 6.39397 9.75 6 9.75C5.60603 9.75 5.21593 9.6724 4.85195 9.52164C4.48797 9.37087 4.15726 9.1499 3.87868 8.87132C3.6001 8.59274 3.37913 8.26203 3.22836 7.89805C3.13865 7.68146 3.07484 7.45562 3.03788 7.22522C2.99613 6.96498 3.21366 6.75 3.47723 6.75C3.74079 6.75 3.94894 6.96649 4.00987 7.22291C4.03495 7.32846 4.06845 7.4321 4.11016 7.5328C4.21296 7.78097 4.36363 8.00647 4.55358 8.19642C4.74353 8.38637 4.96903 8.53704 5.2172 8.63984C5.46538 8.74264 5.73137 8.79555 6 8.79555C6.26863 8.79555 6.53462 8.74264 6.7828 8.63984C7.03097 8.53704 7.25647 8.38637 7.44642 8.19642C7.63637 8.00647 7.78704 7.78097 7.88984 7.5328C7.93155 7.4321 7.96505 7.32846 7.99013 7.22291C8.05106 6.96649 8.25921 6.75 8.52277 6.75Z",
    fill: "#027BFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileFaceFeedback);
export default __webpack_public_path__ + "static/media/smile-face-feedback.7852861463afc384dc902ccca8b2058a.svg";
export { ForwardRef as ReactComponent };